// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-img[data-v-1e56636d] {\n  width: 640px;\n  height: 147px;\n  margin-top: 242px;\n  margin-bottom: 80px;\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n.apple-btn[data-v-1e56636d] {\n  padding-left: 64px;\n  padding-right: 64px;\n}", ""]);
// Exports
module.exports = exports;
